// Mui
import { styled } from '@mui/material/styles';
import IconButtonUI from "@mui/material/IconButton";

export const IconButton = styled(IconButtonUI)(() => ({
  color: '#212121',
}));
